import actionTypes from "./actionTypes";

export const showAppHeader = (show) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.SHOW_APP_HEADER,
      data: show,
    });
  };
};
export const changeHeaderTitle = (title) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_HEADER_TITLE,
      data: title,
    });
  };
};
